import { useState } from "react";

export type StyleVariant = "card" | "plain";

const STORAGE_KEY = "ad_style_variant";

let cached: StyleVariant | null = null;

const readStored = (): StyleVariant | null => {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === "card" || v === "plain" ? v : null;
  } catch {
    return null;
  }
};

const pickAndStore = (): StyleVariant => {
  const variant: StyleVariant = Math.random() < 0.5 ? "card" : "plain";
  try {
    localStorage.setItem(STORAGE_KEY, variant);
  } catch {
    // ignore — Safari private mode, quota exceeded, etc.
  }
  return variant;
};

const resolveVariant = (): StyleVariant => {
  if (cached) return cached;
  cached = readStored() ?? pickAndStore();
  return cached;
};

export const useStyleVariant = (): StyleVariant => {
  const [variant] = useState<StyleVariant>(resolveVariant);
  return variant;
};
